import React from "react";

function CalendarHeader({
    activeView,
    setActiveView,
}) {
    
    const canSwitch = typeof setActiveView === "function" && typeof activeView === "string";

    return (
        // Sticky header
        <div className="sticky z-20 ">
            <div className=" max-w-4xl mx-auto px-4">
                <div className="grid grid-cols-[1fr_auto] items-center gap-2 py-2">

                    <div className="justify-self-end">
                        <div className="inline-flex space-x-2">
                            <button
                                onClick={() => setActiveView("list")}
                                aria-pressed={activeView === "list"}
                                title="List view"
                                className={`relative h-11 w-22 rounded-md overflow-hidden shadow-sm transition
                                ${
                                    activeView === "list"
                                        ? "ring-4 ring-pink-500 ring-offset-2 ring-offset-pink-200 !bg-white"
                                        : "!bg-pink-300"
                                }
                            `}
                            >
                                <img
                                    src="/Button-list.png"
                                    alt="List view"
                                    className="absolute inset-0 h-full w-full object-cover"
                                    draggable={false}
                                />
                            </button>

                            <button
                                onClick={() => setActiveView("calendar")}
                                aria-pressed={activeView === "calendar"}
                                title="Calendar view"
                                className={`relative h-11 w-22 rounded-md overflow-hidden shadow-sm transition
                            ${
                                    activeView === "calendar"
                                        ? "ring-4 ring-pink-500 ring-offset-2 ring-offset-pink-200 !bg-white"
                                        : "!bg-pink-300"
                                }
                            `}
                            >
                                <img
                                    src="/Button-grid.png"
                                    alt="Calendar view"
                                    className="absolute inset-0 h-full w-full object-cover"
                                    draggable={false}
                                />
                            </button>
                        </div>
                    </div>


                    
                </div>
            </div>
            <div className="h-px w-full bg-pink-600 mt-1" />
        </div>
    );
}

export default CalendarHeader;